/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

    module.exports = __webpack_require__(1);


    /***/ }),
    /* 1 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    __webpack_require__(2);
    
    var _menus = __webpack_require__(3);
    
    var _menus2 = _interopRequireDefault(_menus);
    
    var _processflow = __webpack_require__(4);
    
    var _processflow2 = _interopRequireDefault(_processflow);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    (0, _menus2.default)();
    (0, _processflow2.default)();
    
    /***/ }),
    /* 2 */
    /***/ (function(module, exports) {
    
    // removed by extract-text-webpack-plugin
    
    /***/ }),
    /* 3 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    /*global document, setTimeout, Event, window*/
    var OPEN_CLASS = 'open';
    var CLOSING_CLASS = 'closing';
    var CLICK = 'click';
    var KEY_DOWN = 'keydown';
    
    var polyFillPath = function polyFillPath() {
      if (!('path' in Event.prototype)) Object.defineProperty(Event.prototype, 'path', {
        get: function get() {
          var path = [];
          var currentElem = this.target;
          while (currentElem) {
            path.push(currentElem);
            currentElem = currentElem.parentElement;
          }
          if (path.indexOf(window) === -1 && path.indexOf(document) === -1) path.push(document);
          if (path.indexOf(window) === -1) path.push(window);
          return path;
        }
      });
    };
    
    var findElementByID = function findElementByID(id) {
      return document.getElementById(id);
    };
    
    var enterOrSpaceKeyPressHandler = function enterOrSpaceKeyPressHandler(handler) {
      return function (event) {
        var keyCode = event.keyCode;
        if (keyCode === 13 || keyCode === 32) {
          handler(event);
        }
      };
    };
    
    var escapeKeyPressHandler = function escapeKeyPressHandler(handler) {
      return function (event) {
        if (event.keyCode === 27) {
          handler(event);
        }
      };
    };
    
    var addClickAndEnterEvents = function addClickAndEnterEvents(target, handler) {
      target.addEventListener(CLICK, handler);
      target.addEventListener(KEY_DOWN, enterOrSpaceKeyPressHandler(handler));
    };
    
    var addClickAndEscapeEvents = function addClickAndEscapeEvents(target, handler) {
      target.addEventListener(CLICK, handler);
      target.addEventListener(KEY_DOWN, escapeKeyPressHandler(handler));
    };
    
    var removeClickAndEscapeEvents = function removeClickAndEscapeEvents(target, handler) {
      target.removeEventListener(CLICK, handler);
      target.removeEventListener(KEY_DOWN, escapeKeyPressHandler(handler));
    };
    
    var isClickOutsideToggle = function isClickOutsideToggle(target, path) {
      var index = path.indexOf(target);
      //if we click inside the heading the target element will be at either 0, or 1 in the path
      return !(index === 0 || index === 1);
    };
    
    var closeSiblingsOfTarget = function closeSiblingsOfTarget(target) {
      removeClassFromElement(target.parentElement.children, OPEN_CLASS);
    };
    
    var addClassToElement = function addClassToElement(targets, className) {
      targets.forEach(function (target) {
        target.classList.add(className);
      });
    };
    
    var removeClassFromElement = function removeClassFromElement(targets, className) {
      for (var i = 0; i < targets.length; i++) {
        //use loop instead of foreach so we can handle htmlCollections
        targets[i].classList.remove(className);
      }
    };
    
    var getClassTargets = function getClassTargets(target, addOpenClassToBody) {
      return addOpenClassToBody ? [target, document.body] : [target];
    };
    
    var close = function close(target, outsideMenuClickHandler, insideMenuClickHandler) {
      addClassToElement([target], CLOSING_CLASS);
      setTimeout(function () {
        removeClassFromElement([target, document.body], OPEN_CLASS);
        removeClassFromElement([target, document.body], CLOSING_CLASS);
      }, 350);
      removeClickAndEscapeEvents(document.body, outsideMenuClickHandler);
      target.removeEventListener(CLICK, insideMenuClickHandler);
    };
    
    var getToggleMethodForTarget = function getToggleMethodForTarget(target) {
      var closeSiblings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var addOpenClassToBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    
      // catch any events inside the menu and stop them bubbling to the outsideMenuClickHandler
      // Elements inside the menu will receive the event first and so their functionality will not be affected
      var insideMenuClickHandler = function insideMenuClickHandler(event) {
        var path = event.path || event.composedPath && event.composedPath();
        if (isClickOutsideToggle(target, path)) {
          event.stopPropagation();
          return;
        }
        close(target, outsideMenuClickHandler, insideMenuClickHandler);
      };
    
      //close the menu whenever we click anywhere outside the menu
      var outsideMenuClickHandler = function outsideMenuClickHandler(event) {
        event.stopPropagation();
        close(target, outsideMenuClickHandler, insideMenuClickHandler);
      };
    
      return function (event) {
        if (!target.classList.contains(OPEN_CLASS)) {
          event.stopPropagation();
          if (closeSiblings) {
            closeSiblingsOfTarget(target);
          }
          addClassToElement(getClassTargets(target, addOpenClassToBody), OPEN_CLASS);
          addClickAndEscapeEvents(document.body, outsideMenuClickHandler);
          target.addEventListener(CLICK, insideMenuClickHandler);
        }
      };
    };
    
    var attachNavToggle = function attachNavToggle(toggleID, targetId) {
      var addOpenClassToBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    
      var toggle = findElementByID(toggleID);
      if (toggle) {
        addClickAndEnterEvents(toggle, getToggleMethodForTarget(findElementByID(targetId), false, addOpenClassToBody));
      }
    };
    
    var attachSelfToggles = function attachSelfToggles() {
      var nodesArray = Array.prototype.slice.call(document.querySelectorAll('[data-self-toggle]'));
    
      nodesArray.forEach(function (target) {
        addClickAndEnterEvents(target, getToggleMethodForTarget(target, true, true));
      });
    };
    
    var menus = function menus() {
      polyFillPath();
      document.addEventListener('DOMContentLoaded', function () {
        // call all set up methods
        attachNavToggle('navToggle', 'primaryNav', true);
        attachNavToggle('searchToggle', 'headerSearch');
        attachSelfToggles();
      });
    };
    
    exports.default = menus;
    
    /***/ }),
    /* 4 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    /*global document*/
    
    var root = function root() {
      return document.body.querySelector('#processflow');
    };
    
    // get list of elements
    var getSteps = function getSteps() {
      return [].slice.call(root().querySelectorAll('.processflow__step'));
    };
    
    var getIndicators = function getIndicators() {
      return [].slice.call(root().querySelectorAll('.processflow__indicator'));
    };
    
    // Get elements by id
    var getStep = function getStep(id) {
      return root().querySelector('.processflow__step[data-step="' + id + '"]');
    };
    
    var getContent = function getContent(id) {
      return root().querySelector('.processflow__content[data-step="' + id + '"]');
    };
    
    var getIndicator = function getIndicator(id) {
      return root().querySelector('.processflow__indicator[data-step="' + id + '"]');
    };
    
    // Get active elements
    var getActiveStep = function getActiveStep() {
      return root().querySelector('.processflow__step--active');
    };
    
    var getActiveContent = function getActiveContent() {
      return root().querySelector('.processflow__content--active');
    };
    
    var getActiveIndicator = function getActiveIndicator() {
      return root().querySelector('.processflow__indicator--active');
    };
    
    var updateActiveContent = function updateActiveContent(id) {
      var content = getContent(id);
      if (content && !content.classList.contains('processflow__content--active')) {
        // Remove active content class for current
        var active = getActiveContent();
        if (active) {
          active.classList.remove('processflow__content--active');
        }
    
        // Add active class to current
        content.classList.add('processflow__content--active');
      }
    };
    
    var updateMobileNavigation = function updateMobileNavigation(id) {
      var indicator = getIndicator(id);
      if (indicator && !indicator.classList.contains('processflow__indicator--active')) {
        // Remove active content class for current
        var active = getActiveIndicator();
        if (active) {
          active.classList.remove('processflow__indicator--active');
        }
    
        // Add active class to current
        indicator.classList.add('processflow__indicator--active');
      }
    };
    
    var selectTab = function selectTab(step) {
      if (!step.classList.contains('processflow__step--active')) {
        // Remove current active step
        getActiveStep().classList.remove('processflow__step--active');
    
        // Set new active step
        step.classList.add('processflow__step--active');
      }
    
      // Update mobile navigation indicators
      updateMobileNavigation(step.dataset.step);
    
      // Show the content for this step only
      updateActiveContent(step.dataset.step);
    };
    
    var handleSelectTab = function handleSelectTab(e) {
      e.preventDefault();
    
      // We can either click on "A" tag or an "LI" tag. If we're using the a tag,
      // we need to apply to the active class to the parent.
      var step = e.target;
      if (step.tagName == 'A') {
        step = step.parentNode;
      }
    
      selectTab(step);
    };
    
    var handleSelectIndicator = function handleSelectIndicator(e) {
      var indicator = e.target;
      if (indicator.tagName == 'BUTTON') {
        indicator = indicator.parentNode;
      }
    
      var step = getStep(indicator.dataset.step);
      if (step) {
        selectTab(step);
      }
    };
    
    var handleSelectPrevTab = function handleSelectPrevTab(e) {
      e.preventDefault();
    
      var prev = getActiveStep().previousElementSibling;
      if (prev) {
        selectTab(prev);
      }
    };
    
    var handleSelectNextTab = function handleSelectNextTab(e) {
      e.preventDefault();
    
      var next = getActiveStep().nextElementSibling;
      if (next) {
        selectTab(next);
      }
    };
    
    var setupClickEvents = function setupClickEvents(el) {
      getSteps().forEach(function (step) {
        step.addEventListener('click', handleSelectTab);
      });
    
      var nextButton = el.querySelector('.processflow__next');
      if (nextButton) {
        nextButton.addEventListener('click', handleSelectNextTab);
      }
    
      var prevButton = el.querySelector('.processflow__prev');
      if (prevButton) {
        prevButton.addEventListener('click', handleSelectPrevTab);
      }
    
      getIndicators().forEach(function (indicator) {
        indicator.addEventListener('click', handleSelectIndicator);
      });
    };
    
    var processFlow = function processFlow() {
    
      document.addEventListener('DOMContentLoaded', function () {
        var rootEl = root();
        if (rootEl) {
          setupClickEvents(rootEl);
        }
      });
    };
    
    exports.default = processFlow;
    
    /***/ })
    /******/ ]);
    //# sourceMappingURL=main.js.map